module.exports = __webpack_public_path__ + "img/37.20c8d237.jpg";